import { render } from "./edit.vue?vue&type=template&id=a04900de&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=a04900de&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a04900de"],['__file',"src/views/game/task/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a04900de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a04900de', __exports__)) {
    console.log('reload')
    api.reload('a04900de', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=a04900de&scoped=true", () => {
    console.log('re-render')
    api.rerender('a04900de', render)
  })

}


export default __exports__